import { FeeCreateAPIDataRequest } from "gen/model/feeCreateAPIDataRequest";
import { FeeInformationData } from "gen/model/feeInformationData";
import { cloneDeep } from "lodash-es";

// FIXME: Unify these backend models
export const feeInformationToCreation = (
  info: FeeInformationData,
): FeeCreateAPIDataRequest => {
  const { fee, fund_ids, fee_calculation_info, ...otherInfo } = cloneDeep(info);
  return {
    ...otherInfo,
    fee,
    fund_ids,
    fee_calculations: fee_calculation_info.map((calc) => ({
      ...calc,
      fee_parts: calc.fee_parts.map((part) => ({
        fee_basis_id: part.fee_basis_id,
        fee_rate: part.fee_rate,
      })),
    })),
  };
};
